import { Center, Stack, Text, ThemeIcon } from "@mantine/core";
import { Inbox } from "lucide-react";

type EmptyTabStateProps = {
  title: string;
  description: string;
  icon?: React.ReactNode;
};

const EmptyTabState = ({ title, description, icon }: EmptyTabStateProps) => (
  <Center className="py-16">
    <Stack gap={8} align="center" className="px-4">
      <ThemeIcon variant="light" color="gray" size={52} radius="xl">
        {icon || <Inbox size={24} />}
      </ThemeIcon>
      <Text fw={600} c="text.9" size="sm">
        {title}
      </Text>
      <Text size="sm" c="text.5" ta="center" maw={320}>
        {description}
      </Text>
    </Stack>
  </Center>
);

export default EmptyTabState;
